import React from 'react'
import { Navigate, Route } from 'react-router-dom'
import AdminAccount from './pages/AdminAccount/Main'
import DashboardAdmin from './pages/DashboardSetting/Main'
import DataSourceForm from './pages/DataSource/DataSourceForm'
import DataSource from './pages/DataSource/Main'
import ExportList from './pages/Export/ExportList'
import LocationForm from './pages/Location/LocationForm'
import Location from './pages/Location/Main'
import MappingKey from './pages/MappingKey/Main'
import Profile from './pages/Profile/Profile'
import CriteriaDetail from './pages/Segment/Criteria/CriteriaDetail'
import Segment from './pages/Segment/Main'
import SegmentDetail from './pages/Segment/Segment/SegmentDetail'
import Targeting from './pages/Targeting/Main'
import TargetPreview from './pages/Targeting/TargetPreview'
import Taxonomy from './pages/Taxonomy/Main'
import DashboardSetting from './pages/DashboardSetting/DashboardSetting'
import { DashboardCategory } from './constants/DashboardConf'
import Group from './pages/Group/Main'
import SegmentPreview from './pages/Segment/Segment/SegmentPreview'
import TrackTable from './pages/Group/TrackTable'
import SiteTable from './pages/Group/SiteTable'

export default [
  <Route key="profile" exact path="/admin/profile" element={<Profile adminMode />} />,

  <Route key='dashboard' exact path="/admin" element={<Navigate to="/admin/dashboard" replace />}/>,
  <Route key='dashboard' exact path="/admin/dashboard">
    <Route index element={<DashboardAdmin adminMode />}/>
    <Route exact path="consumer360Setting" element={<DashboardSetting goBackPath="/admin/dashboard" type={DashboardCategory.CONSUMER} adminMode />}/>
    <Route exact path="segmentSetting" element={<DashboardSetting goBackPath="/admin/dashboard" type={DashboardCategory.SEGMENT} adminMode />}/>
    <Route exact path="groupDashboardSetting" element={<DashboardSetting goBackPath="/admin/dashboard" type={DashboardCategory.GROUP} adminMode />}/>
    <Route exact path="brandDashboardSetting" element={<DashboardSetting goBackPath="/admin/dashboard" type={DashboardCategory.BRAND} adminMode />}/>
  </Route>,

  <Route key='dataSource' exact path="/admin/dataSource">
    <Route index element={<DataSource adminMode />}/>
    <Route exact path="detail" element={<DataSourceForm goBackPath="/admin/dataSource" editMode viewOnly />}/>
  </Route>,

  <Route key="location" exact path="/admin/location">
    <Route index element={<Location adminMode />}/>
    <Route exact path="detail" element={<LocationForm goBackPath="/admin/location" editMode viewOnly />}/>
  </Route>,

  <Route key='segment' exact path="/admin/segment">
    <Route index element={<Segment viewOnly adminMode />}/>
    <Route exact path="detail" element={<SegmentDetail goBackPath="/admin/segment" editMode viewOnly />}/>
    <Route exact path="preview" element={<SegmentPreview goBackPath="/admin/segment" viewOnly />}/>
    <Route exact path="criteria">
      <Route index element={<Navigate to="/admin/segment" state={{ type: 'criteria' }} viewOnly replace />}/>
      <Route exact path="detail" element={<CriteriaDetail goBackPath="/admin/segment/criteria" />}/>
    </Route>
  </Route>,

  <Route key='targeting' exact path="/admin/targeting">
    <Route index element={<Targeting viewOnly adminMode />}/>
    <Route exact path="preview" element={<TargetPreview goBackPath="/admin/targeting" />}/>
  </Route>,

  <Route key='account' exact path="/admin/account">
    <Route index element={<Group adminMode />}/>
    <Route exact path="track" element={<TrackTable />}/>
    <Route exact path="site" element={<SiteTable />}/>
  </Route>,

  <Route key='mappingKey' exact path="/admin/mappingKey" element={<MappingKey adminMode />} />,

  <Route key='taxonomy' exact path="/admin/taxonomy" element={<Taxonomy adminMode />} />,
  <Route key='export' exact path="/admin/export" element={<ExportList />} />,
  <Route key='adminAccount' exact path="/admin/adminAccount" element={<AdminAccount />} />,

  <Route key='dataSource' exact path="/admin/dataSource">
    <Route index element={<DataSource />}/>
    <Route exact path="new" element={<DataSourceForm goBackPath="/management/dataSource" addMode />}/>
    <Route exact path="edit" element={<DataSourceForm goBackPath="/management/dataSource" editMode />}/>
  </Route>
]
